import routes from "./routes";
import { RouterProvider } from 'react-router-dom';
import LoadingPages from './pages/LoadingPages'



function App() {
  return (

      <RouterProvider router={routes} fallbackElement={<LoadingPages />} />

  );
}

export default App;